module.exports = __webpack_public_path__ + "c531c8f04efdb1bbd199e08eee9e8683.png";